import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center pb-10 space-y-10 lg:mx-52" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl" }, "Active Cards", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl" }, "Recently Closed", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl" }, "Upcoming", -1)

import ScorecardImageCard from '@/components/Scorecard/ScorecardImageCard.vue';
import { useScorecardStore } from '@/store/scorecards';
import { Scorecard } from '@/typings/scorecard';
import { computed, onMounted } from 'vue';
import Toolkit from '@/components/Admin/Toolkit.vue';
import { useUserStore } from '@/store/users';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const scorecardStore = useScorecardStore();
const userStore = useUserStore();

function addWeek(date: string) {
  try {
    const result = new Date(date);
    result.setDate(result.getDate() + 7);
    return result;
  } catch (e) {
    return new Date();
  }
}

function inactiveEvent(scorecard: Scorecard) {
  const isInactive = ['Finalising'].includes(scorecard.Status);
  const recentlyClosed =
    scorecard.Status === 'Closed' &&
    addWeek(scorecard.ClosedAt) > new Date() &&
    scorecard.ClosedAt;
  return isInactive || recentlyClosed;
}

function activeEvent(scorecard: Scorecard) {
  return ['Open', 'Locked'].includes(scorecard.Status);
}

const nextEvents = computed(() => {
  const nextEvents = scorecardStore.scorecards.filter(activeEvent);
  return nextEvents.sort(
    (a, b) => Date.parse(a.LocksAt) - Date.parse(b.LocksAt)
  );
});

const closedEvents = computed(() => {
  const nextEvents = scorecardStore.scorecards.filter(inactiveEvent);
  return nextEvents.sort(
    (a, b) => Date.parse(a.LocksAt) - Date.parse(b.LocksAt)
  );
});

const upcomingEvents = computed(() => {
  const nextEvents = scorecardStore.scorecards.filter(
    (scorecard) => scorecard.Status === 'Scheduled'
  );
  return nextEvents.sort(
    (a, b) => Date.parse(a.LocksAt) - Date.parse(b.LocksAt)
  );
});

onMounted(() => {
  scorecardStore.getScorecards();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userStore).user?.PrivilegeId === 1)
      ? (_openBlock(), _createBlock(Toolkit, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(nextEvents).length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nextEvents), (scorecard) => {
            return (_openBlock(), _createBlock(ScorecardImageCard, {
              key: scorecard.Slug,
              scorecard: scorecard
            }, null, 8, ["scorecard"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    (_unref(closedEvents).length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(closedEvents), (scorecard) => {
            return (_openBlock(), _createBlock(ScorecardImageCard, {
              key: scorecard.Slug,
              scorecard: scorecard
            }, null, 8, ["scorecard"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    (_unref(upcomingEvents).length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(upcomingEvents), (scorecard) => {
            return (_openBlock(), _createBlock(ScorecardImageCard, {
              key: scorecard.Slug,
              scorecard: scorecard
            }, null, 8, ["scorecard"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})